import { Component, OnInit } from '@angular/core';
import { IncidentsService } from '@shared/services/layer-service/incidents-service/incidents.service';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  ButtonClassesEnum,
  IButtonModel,
  IconClassesEnum,
  IClassesAttributes,
} from '@types-custom/models/ui/button-model';
import { GeoApiService } from '@shared/services/geo-api-service/geo-api.service';
import { GeoAPITypeEnum } from '@shared/models/geo-api-type.model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { SituationTypeFilterEnum,
        SituationStateFilterEnum,
        SituationPriorityFilterEnum,
        SituationCategoryFilterEnum,
} from '@shared/models/situations.model';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-map-filter-incidents',
  templateUrl: './map-filter-incidents.component.html',
  styleUrls: ['./map-filter-incidents.component.scss'],
})
export class MapFilterIncidentsComponent implements OnInit {

  situationTypeFilterEnum = SituationTypeFilterEnum;
  situationStateFilterEnum = SituationStateFilterEnum;
  situationPriorityFilterEnum = SituationPriorityFilterEnum;

  filterCategoryOptions:string[];
  defaultDateStart = (new Date(new Date().setHours(0,0,0,0))).toISOString();
  defaultDateEnd = (new Date().toISOString());
  filters: {[key:string]: any} = {
    situationIds: { [SituationTypeFilterEnum.Incidente]: false, [SituationTypeFilterEnum.Evento]: false},
    stateIds: {[SituationStateFilterEnum.Abierto]: false, [SituationStateFilterEnum.Cerrado]: false, [SituationStateFilterEnum.Programado]: false},
    priorityIds: {[SituationPriorityFilterEnum.Alta]: false, [SituationPriorityFilterEnum.Media]: false, [SituationPriorityFilterEnum.Baja]:false},
    categoryId:'',
    categoryName:'',
    defaultDateStart:this.defaultDateStart,
    defaultDateEnd:this.defaultDateEnd
  };
  Icon=Icon;
  buttonTag = 'APLICAR';
  buttonAttributes: IButtonModel = {};
  restorebuttonAttributes: IButtonModel = {};
  applybuttonAttributes : IButtonModel = {};
  dropdownAttributes: IClassesAttributes = {};
  incidentsList: any = [];
  incidentsTypes: [] = [];
  formBuilder = new FormBuilder();
  incidentForm: FormGroup;
  semaforosChecked = false;
  currentDate = new Date();
  minStartDate = new Date();
  createButtonProps: IButtonModel = {
    label: 'APLICAR',
    classAttributes: {
      buttonClass: ButtonClassesEnum.primary_1_button,
      spanClass: IconClassesEnum.text_complementary_2,
    },
  };

  constructor(
    private incidentsService: IncidentsService,
    private geoApiService: GeoApiService
  ) {}

  ngOnInit() {
    this.minStartDate.setDate(this.currentDate.getDate() - 30);
    this.generateButtonAttributes();
    this.getSituationsOptions();

    this.incidentsService.getFilter().subscribe((data) => {
      if(data) {
        this.filters = data;
      }
    });
  }

  private generateButtonAttributes(): void {
    this.buttonAttributes = {
      label: this.buttonTag,
      postIcon: Icon.search_w,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter,
      },
    };
    this.restorebuttonAttributes = {
      label: 'LIMPIAR',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.filter_button,
        spanClass: 'text-weight-600 text-size-16 h-150 p-40-px mt-18'
      },
    };
    this.applybuttonAttributes = {
      label: 'BUSCAR',
      postIcon: undefined,
      classAttributes: {
        buttonClass: ButtonClassesEnum.primary_1_button_filter,
      },
    };
  }

  get startDate() {
    return this.incidentForm.get('dateInit');
  }

  get endDate() {
    return this.incidentForm.get('dateEnd');
  }

  getIncidentsList() {
    this.incidentsService.getfiltersIncidents().subscribe((response) => {
      this.incidentsTypes = response;
      this.incidentsList = response.map((item: any) => item.name);
      this.initForm(this.incidentsList);
    });
  }

  initForm(requiredFilters: string[]): void {
    const formControls: { [key: string]: any } = {
      dateInit: [
        this.currentDate.toLocaleDateString('fr-CA'),
        [Validators.required],
      ],
      timeInit: ['00:00', [Validators.required]],
      dateEnd: [
        this.currentDate.toLocaleDateString('fr-CA'),
        [Validators.required],
      ],
      timeEnd: ['23:59', [Validators.required]],
    };

    requiredFilters.forEach((filter: string) => {
      formControls[filter] = [''];
    });

    this.incidentForm = this.formBuilder.group(formControls, {
      validators: [this.dateValidator],
    });
  }

  private dateValidator: ValidatorFn = (
    group: AbstractControl
  ): ValidationErrors | null => {
    const endDate = new Date(group.get('dateEnd').value);
    const startDate = new Date(group.get('dateInit').value);
    let errors: any;

    if (startDate > this.currentDate) {
      errors = { greaterThanCurrentDate: true };
      group.get('dateInit').setErrors(errors);
      return errors;
    }

    if (endDate > this.currentDate) {
      errors = { greaterThanCurrentDate: true };
      group.get('dateEnd').setErrors(errors);
      return errors;
    }

    if (endDate < startDate) {
      errors = { lessThanStartDate: true };
      group.get('dateEnd').setErrors(errors);
      return errors;
    }

    return null;
  };

  reloadData(response: any) {
    this.incidentsService.incidentFilterNotifier$.next(response);
    this.incidentsService.setFilter(cloneDeep(this.filters));
    // validar si esta es la mejor opción
    document.querySelector<HTMLElement>('#Filtro').click();
    // para resaltar que se aplicó el filtro
    setTimeout(() => {
      document.querySelector<HTMLElement>('#Filtro').parentElement.classList.add('applied-filter');
      // Remover marker seleccionado
      document.querySelector('.marker-active-situations-layer')?.classList.remove('marker-active-situations-layer');
    }, 10);
  }

  reloadRemoveData(response: any) {
    this.incidentsService.incidentFilterNotifier$.next(response);
    this.incidentsService.setFilter(cloneDeep(this.filters));
    // validar si esta es la mejor opción
    document.querySelector<HTMLElement>('#Filtro').click();
    // para resaltar que se aplicó el filtro
    setTimeout(() => {
      document.querySelector<HTMLElement>('#Filtro').parentElement.classList.remove('applied-filter');
      // Remover marker seleccionado
      document.querySelector('.marker-active-situations-layer')?.classList.remove('marker-active-situations-layer');
    }, 10);
  }

  formatCheckboxFilters() {
    const checkedFields = Object.keys(this.incidentForm.value).filter(
      (fieldName) => {
        return this.incidentForm.value[fieldName] === true;
      }
    );
    return checkedFields.map((fieldName) => {
      const typeFounded: any = this.incidentsTypes.find(
        (incitentType: any) => incitentType.name === fieldName
      );
      return typeFounded['id'];
    });
  }

  addLeftZero(digit: number) {
    if (digit.toString().length > 1) {
      return digit;
    }
    return `0${digit}`;
  }

  formatDate(date: Date) {
    return `${date.getFullYear()}-${this.addLeftZero(date.getMonth()+1)}-${this.addLeftZero(date.getDate())}T${this.addLeftZero(date.getHours())}:${this.addLeftZero(date.getMinutes())}:${this.addLeftZero(date.getSeconds())}.000Z`;
  }

  getSituationsOptions(){
    this.incidentsService.getFiltersCategory().subscribe((response) => {
      this.filterCategoryOptions = response.map((item: any) => item.name)
    });
  }

  buildButtonsFilter(filterName:any, optionName:any){
    this.filters[filterName][optionName] = !this.filters[filterName][optionName];
  }

  onCategorySelected(event: any): void {
    this.filters['categoryId'] = SituationCategoryFilterEnum[event.value as keyof typeof SituationCategoryFilterEnum] ;
  }

  applyFilter(){
    const initialFilterValue: {[key: string]: any} = {};
    const filters= Object.keys(this.filters).reduce((acc, filterKey) => {
      if (!['situationIds','stateIds','priorityIds'].includes(filterKey)) {
        return acc;
      }
      const formattedFilter = Object.keys(this.filters[filterKey]).reduce((acc, optionName) => {
        if (this.filters[filterKey][optionName]){
          acc.push(optionName)
        }
        return acc;
      }, []);
      acc[filterKey] = formattedFilter;
      return acc;
    }, initialFilterValue )
    let url = Object.keys(filters).reduce((acc, keyFilter) => {
      if(filters[keyFilter].length) {
        const allValues = filters[keyFilter].join(`&${keyFilter}=`)
        return `${acc}&${keyFilter}=${allValues}`
      }
      return acc;
    }, '')
    if(this.filters['categoryId'] != ''){
      url = `&categoryId=${this.filters['categoryId']}${url}`
    }
    url = `&beginDate=${this.formatDate(new Date(this.filters.defaultDateStart))}&endDate=${this.formatDate(new Date(this.filters.defaultDateEnd))}${url}`

    this.geoApiService
    .getSituationsList(GeoAPITypeEnum.Situation, true, url)
    .subscribe({
      next: this.reloadData.bind(this),
    });
  }

  cleanFilter(){
    this.filters = {
      situationIds: { [SituationTypeFilterEnum.Incidente]: false, [SituationTypeFilterEnum.Evento]: false},
      stateIds: {[SituationStateFilterEnum.Abierto]: false, [SituationStateFilterEnum.Cerrado]: false, [SituationStateFilterEnum.Programado]: false},
      priorityIds: {[SituationPriorityFilterEnum.Alta]: false, [SituationPriorityFilterEnum.Media]: false, [SituationPriorityFilterEnum.Baja]:false},
      categoryId:'',
      categoryName:'',
      defaultDateStart: this.defaultDateStart,
      defaultDateEnd: this.defaultDateEnd
    };

    this.geoApiService
    .getSituationsList(GeoAPITypeEnum.Situation, true, undefined)
    .subscribe({
      next: this.reloadRemoveData.bind(this),
    });
  }

}
